<template>
  <div class="c-college-storage-navigation vForm-row mt-4">
    <div class="vForm-field">
      <div class="row d-flex justify-content-center align-items-center">
        <div
          v-show="showBackButton"
          class="col-12 col-md-6 mb-3"
        >
          <button
            class="btn border btn-lg w-100"
            type="button"
            @click="$emit('back-button-clicked')"
          >
            {{ backLabel || "Go Back" }}
          </button>
        </div>
        <div
          v-show="showNextButton"
          class="col-12 col-md-6 mb-3"
        >
          <button
            class="btn border btn-lg btn-primary w-100"
            type="button"
            v-bind="nextButtonOptions"
            @click="$emit('next-button-clicked')"
          >
            <span v-html="nextLabel || 'Next'"/>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "college-storage-navigation",
  props: {
    backLabel: String,
    nextLabel: String,
    showBackButton: {
      type: Boolean,
      default: true
    },
    showNextButton: {
      type: Boolean,
      default: true
    },
    nextButtonOptions: {
      type: Object
    }
  }
};
</script>

<style lang="scss">
.c-college-storage-navigation {
  .btn.btn-primary {
    color: #fff;
  }
}
</style>
